import { startOfDay, startOfMonth } from "date-fns";

const ONE_SEC = 1e3;
const ONE_MIN = 60e3;
const ONE_HOUR = 3600e3;
const ONE_DAY = 24 * ONE_HOUR;

const StartOf = {
  Day: (time = new Date()) => startOfDay(time).getTime(),
  Month: (time = new Date()) => startOfMonth(time).getTime(),
};

export { ONE_SEC, ONE_MIN, ONE_DAY, ONE_HOUR, StartOf }